__webpack_require__.p = "/assets/turbo/398b6c48/universalat/_next/";